import { render, staticRenderFns } from "./CCEvent.vue?vue&type=template&id=712a0ac2&scoped=true&"
import script from "./CCEvent.vue?vue&type=script&lang=ts&"
export * from "./CCEvent.vue?vue&type=script&lang=ts&"
import style0 from "./CCEvent.vue?vue&type=style&index=0&id=712a0ac2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712a0ac2",
  null
  
)

export default component.exports